module.exports = __webpack_public_path__ + "static/media/contact-us-banner.52d2966e.jpg";